import React from 'react';

const ScheduleHeader = ({ date, name, count }) => {
    if (date.includes('Май') || date.includes('Ноябрь')) {
        date = date.replace('Май', 'Мая');
        date = date.replace('Ноябрь', 'Ноября');
    }

    return (
        <header className="b-event">
            <h1 className="b-event__tittle">
                { date }. { name }
                <br/>
                <span className="b-event__count"> ({ count })</span>
            </h1>
        </header>
    );
};

export default ScheduleHeader;
